import { createAdministrationRoutes } from '@gat-ship/administration'
import { createDevRoutes } from '@gat-ship/dev'
import { createAuthRoutes, authRouteGuard } from '@gat-ship/lib/auth'
import {
  appRouteDefinitions,
  isRouteTransitionAllowed,
  routeDefinitions,
  createRouter,
  createWebHistory
} from '@gat-ship/lib/router'
import { createSupportRoutes } from '@gat-ship/support'
import { createUserRoutes } from '@gat-ship/user'
import { AppPageNotFound } from '@gat-ship/vue-components'
import { createStakeholderRoutes } from '@gat-ship/stakeholders'
import { createMailRoutes } from '@gat-ship/mail-test'

const appRouter = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: appRouteDefinitions.root,
      redirect: () => '/dashboard/economics'
    },
    ...createAdministrationRoutes('/admin'),
    ...createUserRoutes('/user'),
    ...createDevRoutes('/dev'),
    ...createSupportRoutes('/support'),
    ...createStakeholderRoutes('/stakeholders'),
    ...createMailRoutes('/mail'),
    {
      path: '/dashboard',
      component: () => import('../views/dashboard-layout.vue'),
      children: [
        {
          path: '/dashboard/economics',
          name: routeDefinitions.dashboard.ex1,
          component: () => import('../views/dashboard.vue')
        }
      ]
    },

    // https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes
    // pathMatch is the name of the param, e.g., going to /not/found yields
    // { params: { pathMatch: ['not', 'found'] }}
    // this is thanks to the last *, meaning repeated params and it is necessary if you
    // plan on directly navigating to the not-found route using its name
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: AppPageNotFound
    },
    // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
    {
      path: '/:pathMatch(.*)',
      name: 'bad-not-found',
      component: AppPageNotFound
    },
    ...createAuthRoutes({
      RouteName: {
        loggedOut: appRouteDefinitions.auth.loggedOut,
        oAuth2Callback: appRouteDefinitions.auth.oAuth2Callback,
        signIn: appRouteDefinitions.auth.signIn,
        signOut: appRouteDefinitions.auth.signOut
      }
    })
  ]
})

appRouter.beforeEach(authRouteGuard)

appRouter.beforeResolve(async (to) => {
  const canProceed = await isRouteTransitionAllowed(to)
  if (!canProceed) {
    return false
  }
})

export default appRouter
